import React, { useContext, useEffect, useState } from 'react'
import './Header.css'
import { CgMenuGridO } from "react-icons/cg";
import { MdLightMode } from "react-icons/md";
import { CiLight } from "react-icons/ci";
import {Link} from 'react-router-dom';
import green from '../assets/Green-Paint.png';
import pink from '../assets/Pink-Paint.png';
import logo_light from '../assets/Logo-light.png';
import logo_dark from '../assets/Logo-dark.png';


import { UserContext } from '../App';


function Header() {
     const [mode,setMode] = useState(0);
     const [menu,setMenu]=useState(0);
     const {theme,setTheme,padding,setPadding}=useContext(UserContext);
     
    useEffect(()=>{
        setTheme(mode);
        setPadding(padding);
    })
    function portfolio(e){
        const nav_item = e.id;
        alert(nav_item)


    }
    function clicked(){
        window.scrollTo(0, 0);
    }
  return (
    <div  className='top-head'  style={{position:"fixed",width:"100%", zIndex: 3}}>
    <div id="top">
    <div id="main-head" className='main-head'>
    <header id="dark" className={theme==0?'header-bg-light':'header-bg-dark'}>
        <img id="green-1" src={green} alt="green-paint" />
        <img id='pink-1' src={pink} alt="pink-paint" />
        <img id="green-2" src={green} alt="green-paint" />
        <img id='pink-2' src={pink} alt="pink-paint" />
        <nav className='nav' id="nav">
            <div className='nav-title'>
                {
                    mode==0?
                    <img  alt="light" src={logo_light}  style={{position:"absolute",width:"80px",top:"10px"}} />
                    :
                    <img  style={{position:"absolute",width:"80px",top:"10px"}} alt="dark" src={logo_dark}/>
                    
                }
                          <div className='marg'>
                            <span style={{marginLeft:"5rem"}} id="name-light">Murali Krishna</span>
                        </div>
                 <div  onClick={()=>{if(mode==0){setMode(1);
                 
                                               setTheme(1);
                                               
                                                
                            document.getElementById("dark").style.backgroundColor="#2f2f31";
                            document.getElementById("dark").style.color="white";
                            document.getElementById("dark").style.borderColor="white";

                            

                 }else if(mode==1){
                    setMode(0);
                    setTheme(0);
                    
                    document.getElementById("dark").style.backgroundColor="#dbe9fa";
                    document.getElementById("dark").style.color="black";
                    document.getElementById("dark").style.borderColor="black";
                    
                 }}} className='theme-mode'>
                    {    
                    
                        mode==0?
                        <div>
                            <MdLightMode/>
                            <small>Dark</small>

                            </div>
                        :
                        <div>
                            <CiLight/>
                            <small>Light</small>
                        </div>

                    }
                 </div>
                

            </div>
            <div className='nav-items'>
                <Link style={{color:mode==0?"black":"white"}}  id="link1" to="/" onClick={clicked} ><span >Portfolio</span></Link>
                <Link style={{color:mode==0?"black":"white"}}  id="link1" to="/services" onClick={clicked}><span>Services</span></Link>
                <Link  style={{color:mode==0?"black":"white"}} id="link1" to="/projects" onClick={clicked}><span>Projects</span></Link>
                <Link style={{color:mode==0?"black":"white"}}   id="link1" to="/about" onClick={clicked} ><span>About</span></Link>

            </div>
            <div className='nav-menu' id={theme==0?"menu-light":'menu-dark'}> 
            <CgMenuGridO  onClick={()=>{
                if(menu==0){
                    
                    setMenu(1);
                    
                    setTheme(1);
                    // document.getElementById("menu-light").style.color="black";
                    document.getElementById("menubarr").style.display="block";
                    document.getElementById("theme-mode-2").style.top="200px";

                    setPadding(1);

                }else{
                    
                    setMenu(0);
                    // document.getElementById("menu-dark").style.color="white";
                    document.getElementById("menubarr").style.display="none";
                    document.getElementById("theme-mode-2").style.top="123px";
                    setPadding(0);
                }
            }}/>
            </div>
        </nav>  

        </header>
        <div onClick={()=>{if(mode==0){setMode(1);
                                       setTheme(0);
                            document.getElementById("dark").style.backgroundColor="#2f2f31";
                            document.getElementById("main-head").style.color="white";
                            document.getElementById("dark").style.borderColor="white";
                            document.getElementById("theme-mode-2").style.backgroundColor="#2f2f31";
                            document.getElementById("theme-mode-2").style.boxShadow="2px 2px 3px #2f2f31";
                        
                 }else if(mode==1){setMode(0);
                    document.getElementById("dark").style.backgroundColor="#dbe9fa";
                    document.getElementById("main-head").style.color="black";
                    document.getElementById("dark").style.borderColor="black";
                    document.getElementById("theme-mode-2").style.backgroundColor="#dbe9fa";
                    document.getElementById("theme-mode-2").style.boxShadow="2px 2px 3px #dbe9fa";
                 }}} className='theme-mode-2' id='theme-mode-2'>
                    {
                        mode==0?
                        <div>
                            <MdLightMode/>
                            <small>Dark</small>

                            </div>
                        :
                        <div>
                            <CiLight/>
                            <small>Light</small>
                        </div>

                    }
                 </div>

                 </div>
                 <div id="menubarr"  style={{display:"none",backgroundColor:mode==0?"white":"black"}}>
                 <div className='menuinside' >

                 <Link style={{color:mode==0?"black":"white"}} id="link2" to="/" onClick={clicked}><span >Portfolio</span></Link>
                <Link style={{color:mode==0?"black":"white"}}  id="link2" to="/services" onClick={clicked} ><span>Services</span></Link>
                <Link style={{color:mode==0?"black":"white"}}  id="link2" to="/projects"  onClick={clicked}><span>Projects</span></Link>
                <Link style={{color:mode==0?"black":"white"}}  id="link2" to="/about" onClick={clicked}><span>About</span></Link>
                 </div>
                 </div>
                 </div>
                 
                </div>
        

  )
}

export default Header
